import allianz_renewal_banner_1 from '../../../../assets/allianz-renewal-banner-1.jpg';
import allianz_renewal_banner_2 from '../../../../assets/allianz-renewal-banner-2.jpg';
import allianz_renewal_banner_3 from '../../../../assets/allianz-renewal-banner-3.jpg';
import allianz_renewal_banner_4 from '../../../../assets/allianz-renewal-banner-4.jpg';

export const getGovernmentDataPartnerBannerImage = (variant: string): string => {
  switch (variant) {
    case '1':
      return allianz_renewal_banner_1;
    case '2':
      return allianz_renewal_banner_2;
    case '3':
      return allianz_renewal_banner_3;
    case '4':
      return allianz_renewal_banner_4;
    default:
      return allianz_renewal_banner_1;
  }
};
